import { Tag } from 'lucide-react';
import { formatCurrency, t } from '../../constants/i18n';
import { DiscountRemoveButton } from './DiscountRemoveButton';

export interface DiscountLineItemProps {
  title?: string | null;
  amountCents: number;
  currency: string;
  onRemove?: () => void;
  theme?: 'red' | 'green';
}

export function DiscountLineItem({
  title,
  amountCents,
  currency,
  onRemove,
  theme = 'red'
}: DiscountLineItemProps) {
  const colors = theme === 'red'
    ? { text: 'text-red-600', textDark: 'text-red-700', border: 'border-red-100', bg: 'bg-red-50' }
    : { text: 'text-green-600', textDark: 'text-green-700', border: 'border-green-100', bg: 'bg-green-50' };

  return (
    <div className={`flex items-center justify-between gap-3 text-xs border ${colors.border} ${colors.bg} rounded-lg px-3 py-2`}>
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <Tag className={`h-3 w-3 shrink-0 ${colors.text}`} />
        <span
          className={`font-medium ${colors.textDark} leading-snug wrap-break-word`}
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          }}
        >
          {title || t('discountTitleFallback')}
        </span>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <span className={`font-bold ${colors.textDark}`}>
          -{formatCurrency(amountCents, currency)}
        </span>
        {onRemove && (
          <DiscountRemoveButton
            onRemove={onRemove}
            className={`h-6 w-6 ${colors.text} hover:${colors.textDark}`}
          />
        )}
      </div>
    </div>
  );
}
